export { default, getStaticProps } from "app/compare/page";
